import React, { useEffect } from 'react';
import 'src/assets/scss/theme.scss';
import { IntlProvider } from 'react-intl';
import ModalLoaderProvider from 'src/components/ModalLoader/Provider';
import AppRoutes from 'src/routes/app-routes';
import AppUpdateDialog from 'src/features/sw-update/app-update-dialog';
import { Toaster } from 'src/components/ui/toaster';
import { ConfirmContextProvider, ConfirmDialog } from 'src/features/confirm-dialog';
import { GlobalErrorBoundary } from 'src/components/GlobalErrorBoundary';
import { initConsoleFilter } from 'src/utils/console-filter';

const App: React.FC = () => {
  // Initialize console filter inside React lifecycle to avoid side effects on import
  useEffect(() => {
    initConsoleFilter();
  }, []);

  return (
    <GlobalErrorBoundary>
      <ConfirmContextProvider>
        <ModalLoaderProvider>
          <IntlProvider locale={'en'}>
            <Toaster />
            <AppUpdateDialog />
            <AppRoutes />
            <ConfirmDialog />
          </IntlProvider>
        </ModalLoaderProvider>
      </ConfirmContextProvider>
    </GlobalErrorBoundary>
  );
};

export default App;
